export enum REPORT_TYPE {
  REPORT = 'default',
  NOTEBOOK = 'notebook',
  TABLEAU_EMBED = 'tableau_embed',
}
